export default __webpack_public_path__ + "static/media/Jigyasa_06081998.8aae9ddd.pdf";